import { Injectable } from '@angular/core';
import * as io from 'socket.io-client';
import { Observable } from 'rxjs';
import * as Rx from 'rxjs';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';
import { LocalStorageService } from './local-storage.service';
import { LOCAL_STORAGE_CONSTANT } from './local-storage.constant';


@Injectable({
    providedIn: 'root'
})
export class WebsocketService {

    private socket;
    user: any;
    userData: any;
    userObj = {
        id: '',
        name: '',
        username: '',
        email: '',
        author: {}
    }

    constructor(
        private authservice: AuthService,
        private _localStorageService: LocalStorageService
    ) {
        if (this._localStorageService.getItem(LOCAL_STORAGE_CONSTANT.USER_DETAILS)) {
            this.userData = this._localStorageService.getItem(LOCAL_STORAGE_CONSTANT.USER_DETAILS).user;
        }
        //this.getGroupChatList();
        if (this.userData) {
            this.userObj.id = this.userData['chat_sku'];
            this.userObj.name = this.userData['name'];
            this.userObj.username = this.userData['chat_sku'];
            this.userObj.email = this.userData['email'];
            this.userObj.author = {
                id: this.userData['chat_sku'],
                name: this.userData['name'],
                username: this.userData['chat_sku'],
                email: this.userData['email']
            }
        }

    }

    connect(userObj): Rx.Subject<MessageEvent> {
        this.socket = io(environment.socketUrl, {
            query: `auth_token=${environment.chatToken}`,
            transports: ['polling']
        });

        this.socket.on('connect', (connect) => {
            // true
            this.socket.emit('userdata', userObj);
            this.onlineSocket(userObj['id']);
        });
        const observable = new Observable(observer => {
            this.socket.on('new message', (data) => {
                observer.next(data);
                // this.chat.sendMsg('msg');
            });
            this.socket.on('delete message', (data) => {
                observer.next(data);
                // this.chat.sendMsg('msg');
                // console.log(data,"delete evnet test");
                
            });
            this.socket.on('new media', (data) => {
                observer.next(data);
                // this.chat.sendMsg('msg');
            });
            this.socket.on('user online', (data) => {
                const online = {
                    user_id: data,
                    onlineFlag: true
                }
                // data['onlineFlag'] = true;
                observer.next(online);
                // this.chat.sendMsg('msg');
            });
            this.socket.on('user offline', (data) => {
                // data['offlineFlag'] = true;
                const offline = {
                    ...data,
                    offlineFlag: true
                }
                observer.next(offline);
                // this.chat.sendMsg('msg');
            });
            this.socket.on('new block', (data) => {
                const blocked = {
                    ...data,
                    blocked: true
                }
                observer.next(blocked);
                // this.chat.sendMsg('msg');
            });
            this.socket.on('new unblock', (data) => {
                // data['offlineFlag'] = true;
                const unblocked = {
                    ...data,
                    unblocked: true
                }
                observer.next(unblocked);
                // this.chat.sendMsg('msg');
            });
            this.socket.on('new disconnect', (data) => {
                const disconnected = {
                    ...data,
                    disconnected: true
                };
                observer.next(disconnected);
                // this.chat.sendMsg('msg');
            });
            this.socket.on('new connect', (data) => {
                const connected = {
                    ...data,
                    connected: true
                };
                observer.next(connected);
                // this.chat.sendMsg('msg');
            });
            this.socket.on('new disabled', (data) => {
                const disconnected = {
                    ...data,
                    disabled: true
                };
                observer.next(disconnected);
                // this.chat.sendMsg('msg');
            });
            this.socket.on('user_disable', (data) => {
                const disconnected = {
                    user_id: data.user_id,
                    userDeleted: true,
                    is_disable: data.is_disable
                };
                observer.next(disconnected);
                // this.chat.sendMsg('msg');
            });
            this.socket.on('user_logout', (data) => {
                const disconnected = {
                    user_id: data.disableUserId,
                    sa_user_sku_ids: data.sa_user_sku_ids,
                    is_deleted: true
                };
                observer.next(disconnected);
                // this.chat.sendMsg('msg');
            });
            this.socket.on('update cartItem', (data) => {
                const cartData = {
                    user_id: data.user_id,
                    cartCount: data.count,
                    is_cartUpdated: true
                };
                observer.next(cartData);
                // this.chat.sendMsg('msg');
            });
            
            this.socket.on('new enabled', (data) => {
                const enabled = {
                    ...data,
                    enabled: true
                };
                observer.next(enabled);
                // this.chat.sendMsg('msg');
            });
            this.socket.on('new member', (data) => {
                const enabled = {
                    ...data,
                    memberAdded: true,
                };
                observer.next(enabled);
            });
            this.socket.on('delete group', (data) => {
                const enabled = {
                    ...data,
                    groupDelete: true,
                    
                };
                observer.next(enabled);
                console.log("soket delete group")
            });
            this.socket.on('new group', (data) => {
                const enabled = {
                    ...data,
                    groupCreated: true,
                };
                observer.next(enabled);
            });
            this.socket.on('edit group', (data) => {
                const enabled = {
                    ...data,
                    groupEdited: true,
                };
                observer.next(enabled);
            });
            this.socket.on('edit user', (data) => {
                const enabled = {
                    ...data,
                    userEdited: true,
                };
                observer.next(enabled);
            });
            this.socket.on('user disconnect', (data) => {
                const enabled = {
                    ...data,
                    userDisconnect: true,
                };
                observer.next(enabled);
            });

            return () => {
                this.socket.disconnect();
            };
        });

        const observer = {
            next: (data: Object) => {
                if (data['type'] === 'text') {
                    this.socket.emit('message', JSON.stringify(data));
                }
                // if (data['type'] === 'group_event') {
                //     this.socket.emit('message', JSON.stringify(data));
                //     // group event message like user removed user, user was removed by user
                // }
                if (data['type'] === 'media') {
                    this.socket.emit('media', JSON.stringify(data));
                }
                if (data['type'] === 'voice') {
                    this.socket.emit('media', JSON.stringify(data));
                }
            },
        };

        return Rx.Subject.create(observer, observable);
    }

    onlineSocket(id) {
        this.socket.emit('online', id);
    }
    offlineSocket(id) {
        if (this.socket) {
            this.socket.emit('offline', id);
        }
    }
    seenMessage(data) {
        const seenObj = JSON.stringify(data);
        this.socket.emit('seen', seenObj);
    }

    disconnectSocket() {
        if (this.socket) {
            this.socket.disconnect();
        }
    }
}
